import React from 'react';

import { Inline, Text } from '@atlaskit/primitives/compiled';

import CommentIcon from './comment-icon';

export const CommentCount = ({ numberOfComments }: { numberOfComments: number }) => {
	return (
		<Inline space="space.050">
			<CommentIcon />
			<Text size="small">{numberOfComments}</Text>
		</Inline>
	);
};
